import React, { Fragment, useState, useEffect, useCallback, useRef } from 'react';
import MenuHeader from './MenuHeader';
import Breadcrumb from './Breadcumb/Breadcrumb';
import HotelBreadcrumb from './HotelManager/Breadcrumb';
import { Map } from './google_map';
import ListItem from './List_item/ListItem';
import ListTable from './TaskList/ListTable';
import useApi from "../hooks/useApi";
import CalendarManagementService from '../services/calendar_management.service';
import UserService from "../services/user.service";
import useAuth from "../hooks/useAuth";
import { bindEvent, getPusher, initPusher } from "../services/pusher.service";

const Dashboard = () => {
  const [selectedView, setSelectedView] = useState('list');
  const [mapState, setMapState] = useState({ lat: 46.2643, lng: 6.3166, zoom: 10 });
  const { auth } = useAuth();
  const api = useApi();
  const [coordinates, setCoordinates] = useState([]);
  const [centerSkip, setCenterSkip] = useState([]);
  const [routeMarkers, setRouteMarkers] = useState([]);
  const [bookingCoordinate, setBookingCoordinate] = useState(null);
  const [therapistCoordinate, setTherapistCoordinate] = useState(null);
  const [therapistStatus, setTherapistStatus] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedFlyproFilter, setSelectedFlyproFilter] = useState(null);
  const [filterDate, setFilterDate] = useState(null);
  const calendarRefreshRef = useRef(null);
  const calendarRefreshInFlightRef = useRef(false);
  const calendarLastRefreshRef = useRef(0);
  const isMountedRef = useRef(true);
  const apiRef = useRef(api);
  const isMapView = selectedView === 'map';
  
  const handleItemSelect = (lat, lng, zoom, bookingItem) => {
    const booking = { lat, lng, bookingItem };
    setBookingCoordinate(booking);
    setMapState({ lat, lng, zoom });
    setCenterSkip(false);
  };

  const handleFlyproTransit = (therapistLat, therapistLng, zoom, status, flypro) => {
    const therapist = { lat: therapistLat, lng: therapistLng, flypro: flypro };
    setTherapistCoordinate(therapist);
    setTherapistStatus(status);
    setCenterSkip(false);
    // setMapState({ lat: therapistLat, lng: therapistLng, zoom });
  };

  useEffect(() => {
    apiRef.current = api;
  }, [api]);

  useEffect(() => {
    if (bookingCoordinate) {
      if (therapistCoordinate && therapistStatus === 'IN_TRANSIT') {
        // Show route if in transit
        setCoordinates([bookingCoordinate, therapistCoordinate]);
        setRouteMarkers([therapistCoordinate, bookingCoordinate]);
      } else {
        // Clear therapist info if not in transit
        // setCoordinates([bookingCoordinate]);
        setCoordinates([bookingCoordinate, therapistCoordinate]);
        setRouteMarkers([]);
        // if (therapistCoordinate || therapistStatus) {
        //   setTherapistCoordinate(null);
        //   setTherapistStatus(null);
        // }
      }
    }
    console.log('Updated Map State:', { bookingCoordinate, therapistCoordinate, therapistStatus });
    console.log('Updated Map routeMarkers coordinates:', { coordinates, routeMarkers });
  }, [bookingCoordinate, therapistCoordinate, therapistStatus]);

  // Function to update selected view
  const handleViewChange = (view) => {
    setSelectedView(view);
  };

  const handleSkipCenterRefChange = (ref = false) => {
    console.log({ ref });
    setCenterSkip(ref);
  };

  const isHotelManager = auth?.roles?.some(role => role.name === 'ROLE_HOTEL_MANAGER');

  const hasBookingsPermissions = () => {
    return auth?.permissions?.includes('bookings-manage') && auth?.permissions?.includes('bookings-read');
  };

  const applyTherapistLocationUpdate = useCallback((payload) => {
    const therapistId = Number(payload?.therapist_id ?? payload?.id);
    const latitudeRaw = payload?.latitude ?? payload?.lat;
    const longitudeRaw = payload?.longitude ?? payload?.lng;
    if (latitudeRaw == null || longitudeRaw == null) {
      return;
    }

    const latitude = Number(latitudeRaw);
    const longitude = Number(longitudeRaw);

    if (!therapistId || !Number.isFinite(latitude) || !Number.isFinite(longitude)) {
      return;
    }

    setCoordinates((prev) => {
      let updated = false;
      const next = prev.map((coord) => {
        if (coord?.flypro?.id === therapistId) {
          updated = true;
          return {
            ...coord,
            lat: latitude,
            lng: longitude,
            flypro: {
              ...coord.flypro,
              latitude,
              longitude,
            },
          };
        }
        return coord;
      });

      return updated ? next : prev;
    });

    setTherapistCoordinate((prev) => {
      if (!prev || prev?.flypro?.id !== therapistId) {
        return prev;
      }
      return {
        ...prev,
        lat: latitude,
        lng: longitude,
        flypro: {
          ...prev.flypro,
          latitude,
          longitude,
        },
      };
    });
  }, []);

  const dedupeBookingCoords = (list) => {
    const seenBookingIds = new Set();
    const seenCoords = new Set();
    return (list || []).filter((coord) => {
      if (!coord || coord.lat == null || coord.lng == null) {
        return false;
      }
      const bookingId = coord.booking?.id;
      if (bookingId) {
        if (seenBookingIds.has(bookingId)) {
          return false;
        }
        seenBookingIds.add(bookingId);
        return true;
      }
      const key = `${coord.lat},${coord.lng}`;
      if (seenCoords.has(key)) {
        return false;
      }
      seenCoords.add(key);
      return true;
    });
  };

  const handleInitialCoordinatesLoad = (coords, date, skipCenterValue = false) => {
    console.log("Initial load of booking coordinates");
    handleSkipCenterRefChange(skipCenterValue);
    const today = new Date().toISOString().split('T')[0];
    // const datePick = date.toLocaleDateString('en-CA');
    const datePick = date && date !== '' ? date : today;
    const normalizedCoords = dedupeBookingCoords(coords);
    console.log("Date coordinates:", coords, date);
    console.log({ today });
    console.log({ datePick });
    if (datePick !== today) {
      setCoordinates(normalizedCoords);
      console.log("Date coordinates ####");

    } else {
      setSelectedDate(date);
      setCoordinates((prev) => {
        const withoutBookings = prev.filter((c) => !c?.booking);
        return [...withoutBookings, ...normalizedCoords];
      });
      console.log("Date coordinates ====");
    }
  };

  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const fetchCalendarData = useCallback(async () => {
    if (!isMapView) {
      return;
    }

    const userRoles = auth?.roles;
    const isPrivileged = userRoles?.some(role => role.name === "ROLE_ADMIN");
    const todayKey = new Date().toISOString().split('T')[0];
    const shouldShowFlypros = !filterDate || filterDate === todayKey;
    if (!shouldShowFlypros) {
      return;
    }

    try {
      const allCalendarsRaw = await
        CalendarManagementService.index({
          date: new Date().toISOString().split('T')[0],
          with: 'therapist.primary_address,therapist.managers,therapist.media,therapist.zones,calendars_managements_slots.slot',
        }, apiRef.current)
        ;
      console.log("✅ allCalendarsRaw", allCalendarsRaw);

      // Flatten and filter by allowed slot statuses
      const allowedStatuses = ['OVER_TIME', 'AVAILABLE'];

      const filteredCalendars = allCalendarsRaw
        .flat()
        .filter(calendar => {
          const hasAllowedSlot = Array.isArray(calendar.calendars_managements_slots) &&
            calendar.calendars_managements_slots.some(
              slot => allowedStatuses.includes(slot.status)
            );

          if (isPrivileged) {
            return hasAllowedSlot;
          } else {
            return hasAllowedSlot && calendar?.therapist?.managers?.some(manager => manager.id === auth?.user?.id);
          }
          
        });


      console.log("✅ Filtered calendars with available/free/overtime slots:", filteredCalendars);

      const therapistCoords = {};

      filteredCalendars.forEach(calendar => {
        const therapist = calendar.therapist;
        if (therapist?.id && !therapistCoords[therapist.id]) {
          therapistCoords[therapist.id] = {
            lat: therapist.latitude,
            lng: therapist.longitude,
            flypro: therapist,
          };
        }
      });

      const coordinates = Object.values(therapistCoords);
      if (isMountedRef.current) {
        setCoordinates((prev) => {
          const newFlyproIds = new Set(
            coordinates.map((c) => c.flypro.id)
          );
          const filteredPrev = prev.filter(
            (c) => !c.flypro || !newFlyproIds.has(c.flypro.id)
          );
          return [...filteredPrev, ...coordinates];
        });
      }

      console.log("📍 Coordinates for map markers:", coordinates);
    } catch (error) {
      console.error("❌ Error fetching or filtering calendars:", error);
    }
  }, [auth?.roles, auth?.user?.id, filterDate, isMapView]);

  const scheduleCalendarRefresh = useCallback(() => {
    handleSkipCenterRefChange(true);
    if (!isMapView) {
      return;
    }

    if (!calendarRefreshRef.current) {
      return;
    }

    if (calendarRefreshInFlightRef.current) {
      return;
    }

    const now = Date.now();
    if (now - calendarLastRefreshRef.current < 1500) {
      return;
    }

    calendarLastRefreshRef.current = now;
    calendarRefreshInFlightRef.current = true;

    Promise.resolve(calendarRefreshRef.current())
      .catch((error) => {
        console.error("Realtime calendar refresh failed:", error);
      })
      .finally(() => {
        calendarRefreshInFlightRef.current = false;
      });
  }, [isMapView]);

  useEffect(() => {
    calendarRefreshRef.current = fetchCalendarData;
  }, [fetchCalendarData]);

  useEffect(() => {
    if (!isMapView) {
      return;
    }
    fetchCalendarData();
  }, [fetchCalendarData, isMapView, selectedDate]);

  useEffect(() => {
    if (!auth?.accessToken || !isMapView) return;

    initPusher({ token: auth?.accessToken });

    const handler = (data) => {
      const payload =
        typeof data === "string"
          ? (() => {
              try {
                return JSON.parse(data);
              } catch (_) {
                return {};
              }
            })()
          : data || {};

      if (isHotelManager) {
        const hotelId = auth?.user?.hotel?.[0]?.id;
        if (hotelId && payload?.hotel_id && Number(payload.hotel_id) !== Number(hotelId)) {
          return;
        }
      }

      scheduleCalendarRefresh();
    };

    const publicHandler = (data) => {
      const envelope =
        typeof data === "string"
          ? (() => {
              try {
                return JSON.parse(data);
              } catch (_) {
                return {};
              }
            })()
          : data || {};

      const key = envelope?.key;
      if (key !== "dashboard.bookings" && key !== "calendar") {
        return;
      }

      const payload = envelope?.payload || {};

      if (isHotelManager) {
        const hotelId = auth?.user?.hotel?.[0]?.id;
        if (
          hotelId &&
          payload?.hotel_id &&
          Number(payload.hotel_id) !== Number(hotelId)
        ) {
          return;
        }
      }

      scheduleCalendarRefresh();
    };

    const unbindPrivate = bindEvent(
      "private-admin-dashboard",
      "dashboard.bookings.updated",
      handler
    );

    const locationHandler = (data) => {
      const payload =
        typeof data === "string"
          ? (() => {
              try {
                return JSON.parse(data);
              } catch (_) {
                return {};
              }
            })()
          : data || {};

      applyTherapistLocationUpdate(payload);
    };

    const unbindLocation = bindEvent(
      "private-admin-dashboard",
      "therapist.location.updated",
      locationHandler
    );

    const unbindPublic = bindEvent(
      "public-data",
      "realtime.data.updated",
      publicHandler
    );

    return () => {
      unbindPrivate();
      unbindLocation();
      unbindPublic();
    };
  }, [auth?.accessToken, auth?.user?.hotel, applyTherapistLocationUpdate, isHotelManager, isMapView, scheduleCalendarRefresh]);

  useEffect(() => {
    if (!auth?.accessToken || !isMapView) return;

    initPusher({ token: auth?.accessToken });
    const pusher = getPusher();
    if (!pusher) return;

    const handleConnected = () => {
      scheduleCalendarRefresh();
    };

    pusher.connection.bind("connected", handleConnected);

    return () => {
      pusher.connection.unbind("connected", handleConnected);
    };
  }, [auth?.accessToken, isMapView, scheduleCalendarRefresh]);

  useEffect(() => {
    if (!isMapView) {
      return;
    }
    const handleOnline = () => {
      scheduleCalendarRefresh();
    };

    window.addEventListener("online", handleOnline);

    return () => {
      window.removeEventListener("online", handleOnline);
    };
  }, [isMapView, scheduleCalendarRefresh]);




  return (
    <Fragment>
      <MenuHeader />

      {hasBookingsPermissions() && (
        <>
          {isHotelManager ? (
            <HotelBreadcrumb onViewChange={handleViewChange} selected={selectedView} api={api} />
          ) : selectedView === "map" ? (
            <Breadcrumb onViewChange={handleViewChange} selected={selectedView} api={api} onFlyproFilterChange={setSelectedFlyproFilter} onFilterDate={setFilterDate} filterDate={filterDate} auth={auth} />
          ) : (<></>)}

          {selectedView === 'map' && (
            <>
              <Map lat={mapState.lat} lng={mapState.lng} zoom={mapState.zoom} mode="edit" centerSkip={centerSkip} coordinates={coordinates} routeMarkers={routeMarkers} onMarkerClick={(coordinate) => {
                console.log('🧭 Marker clicked:', coordinate);
                handleItemSelect(coordinate.lat, coordinate.lng, 15);
              }} />
              <ListItem onItemSelect={handleItemSelect} onFlyproTransit={handleFlyproTransit} onInitialCoordinatesLoad={handleInitialCoordinatesLoad} selectedFlyproFilter={selectedFlyproFilter} date={filterDate} onSkipCenterRefChange={handleSkipCenterRefChange} />
            </>
          )}
          {selectedView === 'list' && <ListTable showHeader={false} onViewChange={handleViewChange} selected={selectedView} />}
        </>
      )}
    </Fragment>
  );
};

export default Dashboard;
